import { Shark, SmartModel, Utils } from "shark-mvc";
import moment from "moment";

class Gallery extends SmartModel {
	constructor(data) {
		super();

		this.coverURL = "";
		this.createdAt = "0000-00-00 00:00:00";
		this.createdByGuid = "";
		this.description = "";
		this.folderGuid = "";
		this.guid = "";
		this.name = "";
		this.status = 0;
		this.tags = [];
		this.type = "";
		this.updatedAt = "0000-00-00 00:00:00";
		this.updatedByGuid = "";

		this.__hasCoverURL = false;
		this.__fileSize = "";
		this.__tags = "";
	

		if (data) {
			this.import(data);
		}
	}

	export () {
		const exportedData = this.__export();

		exportedData.createdAt = moment.utc(this.createdAt).format("YYYY-MM-DD HH:mm:ss");
		exportedData.status = parseInt(this.status);
		exportedData.tags = JSON.stringify(this.tags);
		exportedData.updatedAt = moment.utc(this.updatedAt).format("YYYY-MM-DD HH:mm:ss");

		return exportedData;
	}

	import(data, options) {
		this.__import(data, options);

		this.createdAt = moment.utc(data.createdAt).local();
		this.status = parseInt(data.status);
		this.tags = Utils.parseJSON(data.tags);
		this.updatedAt = moment.utc(data.updatedAt).local();

		this.fileSize = parseInt(this.fileSize);
		let mbValue = this.fileSize / Math.pow(1024, 2);
		this.__fileSize = mbValue.toFixed(1);
	
		this.__hasCoverURL = this.coverURL !== "";
		this.__tags = this.tags.join(",");
	
	}

	onDataChanged (data) {
		switch (data.property) {
			case "fileURL":
				this.__hasFileURL = this.fileURL !== "";
				break;
			case "coverURL":
				this.__hasCoverURL = this.coverURL !== "";
				break;
			case "fileSize":
				let mbValue = this.fileSize / Math.pow(1024,2);
				this.__fileSize = mbValue.toFixed(1);
				break;
			case "__tags":
				this.tags = data.newValue.split(",").map(item => item.trim());
				break;
		}
	};
}

Shark.registerModel("Gallery", Gallery);

export default Gallery;